import React, { useState, useEffect } from 'react';
import logoWhiteVertical from '../../assets/logos/logo-ai-white-vertical.png';
import alertDesktopOnly from '../../assets/alert-desktoponly.png';
import './MobileDesktopOnlyModal.css';

const MOBILE_BREAKPOINT = 992;

const isMobileDevice = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Check for mobile/tablet user agents
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

  return mobileRegex.test(userAgent);
};

const MobileDesktopOnlyModal: React.FC = () => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const checkShouldShow = () => {
      // Only show if it's a mobile device AND screen is narrow
      setShouldShow(isMobileDevice() && window.innerWidth < MOBILE_BREAKPOINT);
    };

    checkShouldShow();
    window.addEventListener('resize', checkShouldShow);

    return () => window.removeEventListener('resize', checkShouldShow);
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="mobile-desktop-only-overlay">
      <div className="mobile-desktop-only-logo">
        <img src={logoWhiteVertical} alt="Revealer" />
      </div>
      <div className="mobile-desktop-only-modal">
        <h2 className="mobile-desktop-only-title">A Note for Smaller Screens:</h2>
        <div className="mobile-desktop-only-divider"></div>
        <p className="mobile-desktop-only-body">
          Revealer ai is not currently designed for tablet and mobile devices. We're working on this for the near future! For the best experience, please use on desktop.
        </p>
        <div className="mobile-desktop-only-image-container">
          <img
            src={alertDesktopOnly}
            alt="Desktop only"
            className="mobile-desktop-only-image"
          />
        </div>
      </div>
    </div>
  );
};

export default MobileDesktopOnlyModal;
